import { render } from "./UsersProfiles.vue?vue&type=template&id=0fa76de6"
import script from "./UsersProfiles.vue?vue&type=script&lang=js"
export * from "./UsersProfiles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__